import type { Quote } from "../api/types";
import { fmt, t } from "../i18n";
import { brl, pct, rate, usd } from "../lib/money";

/**
 * O custo aberto do preço v3: câmbio base, Taxa FoxyPay (conversão e rede do parceiro dentro), tarifa de destino e
 * IOF; o total vem logo abaixo, em quem usa. `network` nomeia o trilho da conta em dólar (ACH, Fedwire, SWIFT).
 */
export function QuoteRows({ quote, network, withBaseCalc = true }: { quote: Quote; network?: string; withBaseCalc?: boolean }) {
  const plan = quote.pricePlan === "beta" ? t.newPayment.planBeta : quote.pricePlan === "custom" ? t.newPayment.planCustom : null;
  return (
    <>
      <div className="qrow">
        <span className="k">
          {withBaseCalc ? fmt(t.newPayment.rowBaseCalc, { usd: usd(quote.usdCents), rate: rate(quote.rateE8) }) : t.newPayment.rowBase}
          {quote.ptaxE8 && <small className="sub">{fmt(t.newPayment.ptaxRef, { rate: rate(quote.ptaxE8).slice(0, 6) })}</small>}
        </span>
        <span className="v mono">{withBaseCalc ? brl(quote.baseCents) : rate(quote.rateE8)}</span>
      </div>
      <div className="qrow">
        <span className="k">
          {fmt(t.newPayment.rowFee, { pct: pct(quote.feeBp) })}
          <small className="sub">{t.newPayment.rowFeeSub}{plan ? ` · ${plan}` : ""}</small>
        </span>
        <span className="v mono" data-testid="fee">{brl(quote.feeCents)}</span>
      </div>
      <div className="qrow">
        <span className="k">{!quote.destinationIncluded && network ? fmt(t.newPayment.rowDestinationNamed, { network }) : t.newPayment.rowDestination}</span>
        <span className="v mono" data-testid="destination">{quote.destinationIncluded ? t.newPayment.destinationIncluded : brl(quote.destinationCents)}</span>
      </div>
      <div className="qrow">
        <span className="k">{fmt(t.newPayment.rowIof, { pct: pct(quote.iofBp) })}</span>
        <span className="v mono">{brl(quote.iofCents)}</span>
      </div>
    </>
  );
}

export function BankComparison({ quote, disclaimer }: { quote: Quote; disclaimer?: string | null }) {
  if (!quote.bank) return null;
  const text = fmt(t.newPayment.bankCompare, { bank: brl(quote.bank.totalCents), savings: brl(quote.bank.savingsCents) });
  // realça os dois valores
  const parts = text.split(/(R\$ [\d.]+,\d{2}(?: a menos)?)/g);
  return (
    <div className="bank">
      {parts.map((p, i) => (p.startsWith("R$") ? <b key={i}>{p}</b> : <span key={i}>{p}</span>))}
      <small>{disclaimer || quote.bank.disclaimer || t.newPayment.bankDisclaimerDefault}</small>
    </div>
  );
}
